export default "__VITE_ASSET__0c226907__"